
export default function InfoSection() {
  const newsItems = [
    {
      date: '2024.03.15',
      category: 'お知らせ',
      title: '令和6年度税制改正に関するセミナーを開催いたします',
      isNew: true
    },
    {
      date: '2024.03.01',
      category: 'ニュース',
      title: '新オフィス移転のお知らせ - より便利な立地でサービス向上',
      isNew: true
    },
    {
      date: '2024.02.20',
      category: 'セミナー',
      title: '中小企業向け「インボイス制度完全対応セミナー」開催報告',
      isNew: false
    },
    {
      date: '2024.02.10',
      category: 'お知らせ',
      title: 'ゴールデンウィーク期間中の営業についてのご案内',
      isNew: false
    },
    {
      date: '2024.01.25',
      category: 'ニュース',
      title: '顧客満足度調査結果発表 - 98%の高評価をいただきました',
      isNew: false
    },
    {
      date: '2024.01.15',
      category: 'セミナー',
      title: '確定申告準備セミナー「個人事業主のための税務対策」開催',
      isNew: false
    }
  ];

  const resources = [
    {
      icon: 'ri-file-text-line',
      title: '税務カレンダー',
      description: '年間の税務スケジュールを確認できます',
      link: '#'
    },
    {
      icon: 'ri-calculator-line',
      title: '税額シミュレーター',
      description: '簡単な入力で概算税額を計算できます',
      link: '#'
    },
    {
      icon: 'ri-book-line',
      title: '税務ガイド',
      description: '税務に関する基礎知識をまとめています',
      link: '#'
    },
    {
      icon: 'ri-question-line',
      title: 'よくある質問',
      description: 'お客様からよくいただく質問と回答',
      link: '#'
    }
  ];

  return (
    <section id="info" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            情報
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            最新のニュースや税務に関する有用な情報をお届けします
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-10 md:gap-12">
          {/* ニュース・お知らせ */}
          <div className="lg:col-span-2 px-2">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8">
              ニュース・お知らせ
            </h3>
            <div className="space-y-4 sm:space-y-6">
              {newsItems.map((item, index) => (
                <div key={index} className="border-b border-gray-200 pb-4 sm:pb-6 last:border-b-0 cursor-pointer hover:bg-gray-50 p-3 sm:p-4 rounded-lg transition-colors duration-200">
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="text-xs sm:text-sm text-gray-500 whitespace-nowrap">
                      {item.date}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center flex-wrap gap-2 mb-2">
                        <span className="inline-block px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded">
                          {item.category}
                        </span>
                        {item.isNew && (
                          <span className="inline-block px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded">
                            NEW
                          </span>
                        )}
                      </div>
                      <h4 className="text-sm sm:text-base text-gray-900 font-medium hover:text-blue-600 transition-colors duration-200 break-words">
                        {item.title}
                      </h4>
                    </div>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-line text-gray-400"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 便利なツール・資料 */}
          <div className="px-2">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8">
              便利なツール・資料
            </h3>
            <div className="space-y-4">
              {resources.map((resource, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-4 sm:p-6 hover:shadow-md transition-shadow duration-300 cursor-pointer">
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-blue-600 text-white rounded-lg flex-shrink-0">
                      <i className={`${resource.icon} text-lg`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-1 sm:mb-2 break-words">
                        {resource.title}
                      </h4>
                      <p className="text-xs sm:text-sm text-gray-600 break-words">
                        {resource.description}
                      </p>
                    </div>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-external-link-line text-gray-400"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
